import React from 'react'
import './copy-button.css'
import { useLanguage } from '../../i18n/LanguageContext'

function CopyButton({ code, copiedCode, handleCopy }) {
  const { t } = useLanguage()
  const isCopied = copiedCode === code

  return (
    <div className="copy-wrapper">
      <button
        type="button"
        className={`copy-btn ${isCopied ? 'copied' : ''}`}
        onClick={(e) => {
          e.stopPropagation()
          handleCopy(code)
        }}
      >
        <img
          src="https://sunderarmor.com/ui/icon-copy.svg"
          alt="Copy"
          className="copy-icon"
        />
      </button>
      <div className="copy-tooltip">
        {isCopied ? t('copy.copied') : t('copy.copy')}
      </div>
    </div>
  )
}

export default CopyButton
